import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Path from 'components/Path';
import Apex from 'components/Apex';

const TermFilterLabel = memo(({ type, color }) => {
  return (
    <svg width="16" height="16">
      <Path d="M 0 8 H 16" color={color} />

      <Apex x={8} y={8} type={type} color={color} withBorder />
    </svg>
  );
});

TermFilterLabel.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
};

TermFilterLabel.defaultProps = {
  type: 'circle',
  color: 'primary',
};

export default TermFilterLabel;
